<template>
  <van-tabbar 
    class="text-center"
    route
    active-color="#D8271C" 
    inactive-color="#333"
    safe-area-inset-bottom
  >
    <van-tabbar-item to="/">
      <template #icon>
        <i class="tabbar-icon iconfont icon-shouye"></i>
      </template>
      首页
    </van-tabbar-item>
    <van-tabbar-item to="/shopcar">
      <template #icon>
        <i class="tabbar-icon iconfont icon-a-gouwuche1"></i>
      </template>
      购物车
    </van-tabbar-item>
    <van-tabbar-item to="/center">
      <template #icon>
        <i class="tabbar-icon iconfont icon-zhanghuguanli"></i>
      </template>
      个人中心
    </van-tabbar-item>
  </van-tabbar>
</template>

<script>
export default {
  data: ()=>({
    active: 0,
  }),
}
</script>

<style lang="less" scoped>
/deep/.tabbar-icon{
  margin-bottom: .1rem;
}
</style>